export const setPuzzleUrl = url => ({
    type: "PUZZLE_URL",
    url
});

export default (state = '', action = {}) => {
    if(action.type === 'PUZZLE_URL') {
        state = action.url;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/puzzleUrl.js